<template>
    <model-form
        :title="group && group.id ? `Edit Group ${group.name}` : 'Create Group'"
        :formFields="formFields"
        @save="saveGroup"
        @cancel="cancel"
    />
</template>

<script>
import { defineComponent } from "vue";

import ModelForm from "../common/models/ModelForm.vue";
import { groupService } from "@/lib/admin/groupAdmin";
import { fetchAllBenchlingProjects } from "@/services/benchling/benchlingAPI";
import { roleService } from "@/lib/admin/roleAdmin";
import {
    buildMultiSelectField,
    buildNameField,
    buildSelectField,
    buildTextField,
} from "@/lib/vueModelUtils";
import { experimentsAPI } from "@/services/experiments/experimentsAPI.ts";

export default defineComponent({
    name: "GroupForm",

    components: {
        ModelForm,
    },

    computed: {},

    async mounted() {
        const id = this.$route.params.id;
        if (id) {
            this.group = await groupService.fetchById(id);
        } else {
            this.group = {
                name: "",
                roleId: "",
            };
        }
        const roles = await roleService.fetchAll();
        const roleOptions = roles.map((role) => {
            return {
                title: role.name,
                value: role.id,
            };
        });

        const allBenchlingProjects = await fetchAllBenchlingProjects();
        const allPlatforms = await experimentsAPI.fetchPlatforms();
        this.buildFormFields(roleOptions, allBenchlingProjects, allPlatforms);
    },

    methods: {
        buildFormFields(roleOptions, allBenchlingProjects, allPlatforms) {
            this.nameField = buildNameField(this.group.name);
            this.roleField = buildSelectField({
                name: "Role",
                options: roleOptions,
                value: this.group.role ? this.group.role.id : null,
            });

            this.descriptionField = buildTextField({
                label: "Description",
                value: this.group.description ? this.group.description : null,
            });
            this.descriptionField.cols = 12;

            const benchlingProjectOptions = allBenchlingProjects.map((project) => {
                const disabled = project.archived$;
                return {
                    label: project.name,
                    value: project.id,
                    disabled,
                };
            });

            const benchlingProjects = this.group.benchlingProjects;
            const projectIds = benchlingProjects
                ? benchlingProjects.map((project) => project.id)
                : null;

            this.benchlingProjectsField = buildMultiSelectField({
                name: "Benchling Project",
                options: benchlingProjectOptions,
                values: projectIds,
            });

            const platformOptions = allPlatforms.map((platform) => {
                return {
                    label: platform.name,
                    value: platform.id,
                };
            });

            const platforms = this.group.platforms;
            const platformIds = platforms ? platforms.map((platform) => platform.id) : null;

            this.platformsField = buildMultiSelectField({
                name: "Platform",
                options: platformOptions,
                values: platformIds,
            });

            this.formFields = [
                this.nameField,
                this.roleField,
                this.descriptionField,
                this.benchlingProjectsField,
                this.platformsField,
            ];
        },
        async saveGroup() {
            this.saving = true;
            this.group.name = this.nameField.value;
            this.group.roleId = this.roleField.value;
            this.group.description = this.descriptionField.value;
            this.group.benchlingProjectIds = this.benchlingProjectsField.values;
            this.group.platformIds = this.platformsField.values;
            await groupService.save(this.group);
            this.saving = false;
            this.$router.push(`/auth/admin`);
        },
        cancel() {
            this.$router.push(`/auth/admin`);
        },
    },

    data() {
        return {
            isFormValid: false,
            saving: false,
            group: null,
            formFields: [],
        };
    },
});
</script>

<style></style>
